import React, { useMemo } from "react";
import { createRoot } from "react-dom/client"; // ✅ Correct React 18 import
import reportWebVitals from "./reportWebVitals";

// import redux requirements
import { Provider } from "react-redux";
import { PersistGate } from "reduxjs-toolkit-persist/integration/react";
import { store, persistedStore } from "store";

// import html head tags requirements
import { Helmet } from "react-helmet";
import { REACT_HELMET_PROPS } from "./config";

// import multi language
import LangProvider from "lang/LangProvider";

// import routing modules
import { BrowserRouter as Router } from "react-router-dom";
import RouteIdentifier from "routing/components/RouteIdentifier";
import Loading from "components/loading/Loading";

// import routes
import { getLayoutlessRoutes } from "routing/helper";
import defaultRoutes from "routing/default-routes";
import routesAndMenuItems from "./routes";

// import toastify for notification
import { Slide, Zoom, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import recruiterRoutes from "./routes/recruiter.routes";
// mock server register for demo
import "@mock-api";

const Main = () => {
  const layoutlessRoutes = useMemo(
    () => getLayoutlessRoutes({ data: recruiterRoutes }),
    []
  );
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistedStore}>
        <Helmet {...REACT_HELMET_PROPS} />
        <ToastContainer
          position="top-center"
          autoClose={2000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick={false}
          pauseOnFocusLoss
          draggable={false}
          pauseOnHover
          theme="light"
          transition={Zoom}
        />
        <Router basename={process.env.REACT_APP_BASENAME}>
          <LangProvider>
            <RouteIdentifier
              routes={[...layoutlessRoutes, ...defaultRoutes]}
              fallback={<Loading />}
            />
          </LangProvider>
        </Router>
      </PersistGate>
    </Provider>
  );
};

// ✅ Use createRoot instead of ReactDOM.render
const root = createRoot(document.getElementById("root") as HTMLElement);
root.render(<Main />);

// Measure performance
reportWebVitals(console.log);
